/* Top Market — événements : décompte jusqu'au jour J, tenu à jour chaque seconde. */
(() => {
  const deux = (n) => String(n).padStart(2, '0');

  const brancher = (bloc) => {
    if (bloc.dataset.tmPret) return;
    bloc.dataset.tmPret = '1';
    // La date arrive au format 2026-11-02T18:00:00+0000 : on insère les deux-points du fuseau pour tous les navigateurs.
    const cible = new Date(bloc.dataset.tmDecompte.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime();
    if (Number.isNaN(cible)) return;
    const champ = (nom) => bloc.querySelector(`[data-tm-${nom}]`);
    const lu = bloc.querySelector('[data-tm-decompte-texte]');
    let derniereMinute = -1;

    const battre = () => {
      const reste = cible - Date.now();
      if (reste <= 0) {
        clearInterval(minuterie);
        const carte = bloc.closest('[data-tm-evenement]');
        if (carte) carte.closest('li').hidden = true;
        return;
      }
      const s = Math.floor(reste / 1000);
      const jours = Math.floor(s / 86400);
      const heures = Math.floor((s % 86400) / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      champ('jours').textContent = jours;
      champ('heures').textContent = deux(heures);
      champ('minutes').textContent = deux(minutes);
      champ('secondes').textContent = deux(s % 60);
      // Les lecteurs d'écran reçoivent une phrase, rafraîchie à la minute et non à la seconde.
      if (lu && minutes !== derniereMinute) {
        derniereMinute = minutes;
        lu.textContent = `${jours} j ${heures} h ${minutes} min`;
      }
    };
    const minuterie = setInterval(battre, 1000);
    battre();
  };

  const tout = () => document.querySelectorAll('[data-tm-decompte]').forEach(brancher);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  document.addEventListener('shopify:section:load', tout);
})();
